module.exports = __webpack_public_path__ + "static/img/purchase1.4da6afdb.png";